module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_ClarkJohnson-66b6301904a60cbd41f9d6f5ee3d0945.png";